"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactRedux = require("react-redux");
var _uiSelectors = require("../../store/ui/uiSelectors");
var _uiUtils = require("../../utils/uiUtils");
var useCurrentPageContent = function useCurrentPageContent() {
  var currentPage = (0, _reactRedux.useSelector)(_uiSelectors.selectCurrentPage);
  var pageSlots = _uiUtils.CONTEXT_MAP[currentPage];
  return pageSlots;
};
var _default = useCurrentPageContent;
exports.default = _default;